import { EarnApy } from './earn-apy';

export const Badge = {
  EarnApy,
};
